import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useState } from 'react';
import { SearchRecommendation } from './SearchRecommendation';
import { SearchRecommendationModule } from './SearchRecommendation.module';
import { isInteractiveClickTarget } from './utils';
import s from './SearchRecommendation.module.scss';
export const SearchRecommendationList = _ref => {
  let {
    items,
    dataHook,
    onClickGetIt,
    onItemClick,
    onAiInsightsClick,
    onHoverChange,
    isLoading,
    disabled,
    firstSuggestionPrimary = true,
    primaryBadgeOnlyForFirst = false,
    useMobileLayout = false,
    defaultNonHovered = false,
    isLeanView = false,
    useCompactSuggestionRowStyle = false,
    pricingOptimized,
    isPricingLoading = false,
    renderLastDivider = false,
    compactPriceLabel = false,
    titleOverflowStrategy
  } = _ref;
  const [hoveredIndex, setHoveredIndex] = useState(0);
  const [hasHovered, setHasHovered] = useState(false);
  const {
    SearchRecommendationListContainer,
    Divider,
    HoverBox,
    Skeleton
  } = SearchRecommendationModule.SDK.Layouts;
  useEffect(() => {
    onHoverChange == null || onHoverChange(hoveredIndex);
  }, [hoveredIndex, onHoverChange]);
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Skeleton, {
      useMobileLayout: useMobileLayout,
      defaultNonHovered: useCompactSuggestionRowStyle,
      optimized: useCompactSuggestionRowStyle || isLeanView
    });
  }
  const rows = items.map((item, index) => {
    const isActive = index === hoveredIndex;
    // With defaultNonHovered, suppress the initial .hovered styling on the first
    // card — keep the primary button skin via isActive, but only show the
    // hover lift/shadow once the user has actually hovered a card.
    const isHovered = isActive && (!defaultNonHovered || hasHovered);
    const isNextHovered = index + 1 === hoveredIndex && (!defaultNonHovered || hasHovered);
    const isNotLast = index < items.length - 1;
    const shouldHideDivider = (isHovered || isNextHovered) && !useCompactSuggestionRowStyle;
    const divider = (isNotLast || renderLastDivider) && /*#__PURE__*/React.createElement(Divider, {
      className: `${s.divider}${shouldHideDivider ? ` ${s.hidden}` : ''}`
    });
    const row = /*#__PURE__*/React.createElement(SearchRecommendation, _extends({}, item, {
      primary: firstSuggestionPrimary && index === 0,
      primaryBadgeOnly: primaryBadgeOnlyForFirst && index === 0,
      active: useCompactSuggestionRowStyle ? isHovered : isActive,
      onButtonClick: onClickGetIt,
      onAiInsightsClick: onAiInsightsClick,
      isLeanView: isLeanView,
      useCompactSuggestionRowStyle: useCompactSuggestionRowStyle,
      pricingOptimized: pricingOptimized,
      isPricingLoading: isPricingLoading,
      compactPriceLabel: compactPriceLabel,
      titleOverflowStrategy: titleOverflowStrategy,
      showLabelBadge: useCompactSuggestionRowStyle ? false : !isLeanView || index === 0,
      onMouseEnter: useMobileLayout && !defaultNonHovered ? undefined : () => {
        setHoveredIndex(index);
        setHasHovered(true);
      },
      dataHook: `${dataHook}-item-${index}`,
      disabled: disabled,
      useMobileLayout: useMobileLayout
    }));
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: item.id
    }, /*#__PURE__*/React.createElement(HoverBox, {
      display: "block",
      className: [s.searchRecommendation, useCompactSuggestionRowStyle && s.optimized, isHovered && s.hovered].filter(Boolean).join(' ')
    }, onItemClick ? /*#__PURE__*/React.createElement("div", {
      className: s.cardClickArea,
      "data-hook": `${dataHook}-item-${index}-click-area`,
      onClick: event => {
        if (disabled || isInteractiveClickTarget(event.target)) {
          return;
        }
        onItemClick(item);
      }
    }, row) : row), divider);
  });
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(SearchRecommendationListContainer, {
    dataHook: dataHook,
    className: s.searchRecommendationList
  }, rows));
};
//# sourceMappingURL=SearchRecommendationList.js.map